<template>
  <div class="lyear-layout-web">
    <div class="lyear-layout-container">
      <!--左侧导航-->
      <user-left></user-left>
      <!--End 左侧导航-->
      
      <!--头部信息-->
      <user-head></user-head>
      <!--End 头部信息-->
      
      <!--页面主要内容-->
      <main class="lyear-layout-content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-body">
                  
                  <div class="edit-avatar">
                    <img v-if="picture" :src="picture" alt="..." class="img-avatar">
                    <img v-else src="../assets/images/noface.gif" alt="..." class="img-avatar">
                    <div class="avatar-divider"></div>
                    <div class="edit-avatar-content">
											<Upload
													ref="upload"
													:headers="{token:tokenStr}"
													:show-upload-list="false"
													:default-file-list="defaultList"
													:on-success="handleSuccess"
													:format="['jpg','jpeg','png']"
													:max-size="2048"
													:on-format-error="handleFormatError"
													:on-exceeded-size="handleMaxSize"
													type="select"
													name="headPicUrl"
													:action="$baseURL+'/portal/api/user/uploadPic.do'">
													<button class="btn btn-default">修改头像</button>
											</Upload>
                      <p class="m-0">选择一张你喜欢的图片，裁剪后会自动生成264x264大小，上传图片大小不能超过2M。</p>
                    </div>
                  </div>
                  <hr>
									<div class="form-group">
										<label for="nickname">账号名称</label>
										<input disabled="1" type="text" class="form-control" name="nickname"  placeholder="输入您的昵称" v-model="nickName">
									</div>
									<div class="form-group">
										<label for="email">邮箱</label>
										<input type="email" class="form-control" name="email"  aria-describedby="emailHelp" placeholder="请输入正确的邮箱地址"  v-model="email">
										<small id="emailHelp" class="form-text text-muted">请保证您填写的邮箱地址是正确的。</small>
									</div>
									<div class="form-group">
										<label for="remark">简介</label>
										<textarea class="form-control" name="remark" id="remark" rows="3" v-model="memberProfile"></textarea>
									</div>
									<div  class="btn btn-primary" @click="changeInfo">保存</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <!--End 页面主要内容-->
    </div>
  </div>
</template>

<script>
import userLeft from './user_left.vue'
import userHead from './user_head.vue'
export default {
  data () {
    return {
			tokenStr: '',
			nickName: '',
			defaultList: [],  // { name: 'img2.jpg',url: 'http://www.xxx.com/img2.jpg'}
			picture: null,
			email: '',
			memberProfile: ''
		}
  },
	
	components: {
		userLeft,
		userHead
	},

  created () {
		this.tokenStr = localStorage.getItem('token')
		// this.username = localStorage.getItem('username')
		// this.picture = localStorage.getItem('picture') || null
		this.checkToken()
	},

  methods: {
		// 文件上传成功时的钩子
		async handleSuccess (response, file, fileList) {
			let _this = this
			if (response.result != 1) {
				return _this.$Message.error('上传失败')
			}
			const res = await _this.get('/dynamicFile/getApacheUrl.do?recordID=' + response.data)
			_this.picture = res.url
		},
		
		// 文件校验失败时候的钩子
		handleFormatError (file, fileList) {
			
		},
		
		// 文件超出大小时候的钩子
		handleMaxSize (file, fileList) {
			
		},
		
		// 验证token的时效性-获取对应的用户信息
		async checkToken () {
			// 验证token的时效性
			let _this = this
			const tokenState = await this.util.checkToken(localStorage.getItem('token'))
			_this.picture = tokenState.data.picture
			_this.nickName = tokenState.data.username || tokenState.data.nickName
			_this.email = tokenState.data.email
			_this.memberProfile = tokenState.data.memberProfile
		},
		
		// 编辑修改用户信息
		async changeInfo () {
			let _this = this
			let data = {
				nickName: _this.nickName,
				email: _this.email,
				picture: _this.picture,
				memberProfile: _this.memberProfile
			}
			if (data.nickName == '') {
				return _this.$Message.warning('账号名称不能为空')
			}
			if (!_this.util.isEmail(data.email)) {
				return _this.$Message.warning('请输入正确邮箱')
			}
			const res = await _this.post('/user/updateMember.do', data)
			if (res.result == 1) {
				_this.$Message.success('修改成功')
				_this.checkToken()
			} else {
				_this.$Message.error('编辑失败')
			}
		}
		
	}
}
</script>

<style lang="less" scoped>

</style>
